import { Component, Input, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';

import { EventsService } from "../../../core/services/events.service";
import { WishListService } from "../../../core/services/wish-list.service";
import { NetworkService } from "../../../core/services/network.service";

@Component({
    selector: 'profile-purchased',
    templateUrl: './purchased.component.html',
    styleUrls: ['./purchased.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class PurchasedComponent {
    @Input() purchasedItem;

    constructor(
        private router: Router,
        private networkService: NetworkService,
        private eventsService: EventsService,
        private wishlistService: WishListService) {
    }

    backgroundImage() {
        let url = '';
        if (this.purchasedItem.images['264x179']) {
            url = this.purchasedItem.images['264x179'];
        } else {
            url = "/assets/img/logo-template.png";
        }
        return `url(${url})`;
    }

    goToProduct(product) {
        if (product.type === 'courses') {
            this.router.navigate(['/courses', product.id]);
        } else if (product.type === 'packages') {
            this.router.navigate(['/packages', product.id]);
        }
    }
}


// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/(IGH Projects)/jobs/EVFS PROD_FRONTEND granima.de/workspace/frontend/src/app/pages/user-profile/purchased-products/purchased.component.ts